module.exports = __webpack_public_path__ + "img/fourday_ps_16.c58d1d71.jpg";